import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import ReportSelect from './ReportSelect'
import Button from '../../../../components/Button'
import SroiReportPayloadCreate from '../forms/SroiReportPayloadCreate'

import DeleteItemModal from '../../../../features/components/Modals/DeleteItemModal'

import { openForm } from '../../../../modules/actions/forms'
import {
  deleteSroiReportPayloadErrorSelector,
  deleteSroiReportPayloadIsLoadingSelector,
  deleteSroiReportPayloadSelector
} from '../../../../modules/selectors/socialReturnOnInvestment'
import {
  clearDeleteSroiReportPayload,
  deleteSroiReportPayload
} from '../../../../modules/actions/socialReturnOnInvestment'

import { SROI_REPORT_PAYLOAD_EDIT } from '../../../../constants/forms'

import useDeleteAction from '../../../../features/hooks/useDeleteAction'

import useStyles from './styles'

const ReportMenu = ({ selectedYear, selectedReport, setSelectedReport }) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const classes = useStyles()

  const openSroiReportEditForm = useCallback(() => {
    dispatch(openForm({ id: selectedReport.id, formName: SROI_REPORT_PAYLOAD_EDIT }))
  }, [dispatch, selectedReport])

  const deleteReportHandler = useCallback(
    params => {
      dispatch(deleteSroiReportPayload(params))
    },
    [dispatch]
  )

  const clearDeleteReportHandler = useCallback(() => {
    dispatch(clearDeleteSroiReportPayload())
  }, [dispatch])

  const { handleDelete, handleDeleteRequest, handleCloseDeleteModal, isDeleteModalOpened, deleteItemIsLoading } =
    useDeleteAction({
      onDelete: deleteReportHandler,
      onClearDelete: clearDeleteReportHandler,
      deletedItemSelector: deleteSroiReportPayloadSelector,
      deleteItemErrorSelector: deleteSroiReportPayloadErrorSelector,
      deleteItemIsLoadingSelector: deleteSroiReportPayloadIsLoadingSelector
    })

  const openDeleteRequestModal = useCallback(() => {
    handleDeleteRequest({
      item: selectedReport
    })
  }, [handleDeleteRequest, selectedReport])

  return (
    <div className={classes.reportMenu}>
      <ReportSelect selectedYear={selectedYear} selectedReport={selectedReport} setSelectedReport={setSelectedReport} />
      {selectedReport && <Button onClick={openSroiReportEditForm}>{t('Edit report')}</Button>}
      <SroiReportPayloadCreate />
      {selectedReport?.id && (
        <Button className={classes.deleteButton} danger={true} colorful={true} onClick={openDeleteRequestModal}>
          {t('Delete Report')}
        </Button>
      )}
      <DeleteItemModal
        handleDelete={handleDelete}
        handleCloseDeleteModal={handleCloseDeleteModal}
        isDeleteModalOpened={isDeleteModalOpened}
        deleteItemIsLoading={deleteItemIsLoading}
        deleteModalMessage="This can't be undone"
        deleteButtonText="Yes, Delete"
      />
    </div>
  )
}

ReportMenu.propTypes = {
  selectedYear: PropTypes.number,
  selectedReport: PropTypes.object,
  setSelectedReport: PropTypes.func.isRequired
}

export default ReportMenu
